import { useParams } from "react-router-dom";

const useParamsInt = (key = "id") => {
    const params = useParams();
    return params[key] ? parseInt(params[key]) : null;
};

export default useParamsInt;
